import prd from './config/prd'
import prd_intl from './config/prd_intl'
import pre from './config/pre'
import sit from './config/sit'
import local from './config/local'

let config: any
switch (process.env.VUE_APP_TICO_ENV) {
  case 'sit':
    config = sit
    break
  case 'pre':
    config = pre
    break
  case 'prd':
    config = prd
    break
  case 'prd_intl':
    config = prd_intl
    break
  default:
    config = local
    break
}
const commonConfig = {
  ...config
}

export default commonConfig
